import React from 'react';
import { track } from '../modules/tracking';
import PropTypes from 'prop-types';

let Link;

const text = `The new plant-based Nando’s menu item, The Great Imitator,
served in a wrap. Find it on the menu under burgers, pittas,
wraps and order now.`;

const motion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    (window.matchMedia('(prefers-reduced-motion: no-preference)') || {})
        .matches;

if (motion) {
    Link = require('react-anchor-link-smooth-scroll').default;
}

function TheGreatImitator({ section }) {
    const sectionId = (section.id || '').replace(/:/g, '_');

    function afterClick(e) {
        const hash = (e.target.href || '').split('#')[1];
        const section = document.getElementById(hash);
        let name;
        if (section && section.querySelector) {
            name =
                (section.querySelector('h2') || {}).innerText ||
                'burger, pitta, wrap';
        }

        track(`The Great Imitator: Click: Jump page to: ${name}`)();

        const target = document.getElementById(hash);

        if (target) {
            const anchor = target.querySelector('button');
            if (anchor && anchor.focus) {
                if (motion) {
                    setTimeout(() => {
                        anchor.focus();
                    }, 750);
                } else {
                    anchor.focus();
                }
            }
        }
    }

    return (
        <div className='tgi'>
            {motion ? (
                <Link href={`#${sectionId}`} onClick={afterClick}>
                    <span>{text}</span>
                </Link>
            ) : (
                <a href={`#${sectionId}`} onClick={afterClick}>
                    <span>{text}</span>
                </a>
            )}
        </div>
    );
}

TheGreatImitator.propTypes = {
    section: PropTypes.object
};

export { TheGreatImitator };
